import { GHG_WORD_EXPORT_DESIGN_TOKENS } from './ghgWordExportDesign';

const COVER_LOGO_H = GHG_WORD_EXPORT_DESIGN_TOKENS.coverLogoHeightPt;
const COVER_LOGO_MAX_W = GHG_WORD_EXPORT_DESIGN_TOKENS.coverLogoMaxWidthPt;

/**
 * Inline CSS for GHG Word exports (html-docx-js): Bootstrap-style tables and spacing
 * that are missing when outerHTML is taken without the app stylesheet.
 */
export const WORD_DOCX_GHG_COMPAT_INLINE_CSS = `
.table {
  width: 100%;
  margin-bottom: 10pt;
  border-collapse: collapse;
  border-spacing: 0;
  mso-table-lspace: 0pt;
  mso-table-rspace: 0pt;
  vertical-align: top;
  text-align: left;
}
.table-bordered,
table.table-bordered {
  border: 1px solid #dee2e6;
}
.table-bordered > :not(caption) > * > *,
table.table-bordered > :not(caption) > * > * {
  border: 1px solid #dee2e6;
  border-width: 1px;
  box-shadow: none !important;
}
.table-sm > :not(caption) > * > * {
  padding: 2pt 4pt;
}
.text-right,
.text-end,
th.text-right,
td.text-right,
th.text-end,
td.text-end {
  text-align: right !important;
}
.mb-1 { margin-bottom: 3pt !important; }
.mb-2 { margin-bottom: 6pt !important; }
.mb-3 { margin-bottom: 10pt !important; }
.mb-4 { margin-bottom: 12pt !important; }
.mb-5 { margin-bottom: 18pt !important; }
.mt-2 { margin-top: 6pt !important; }
.ps-4 { padding-left: 18pt !important; }
.ghg-section .ps-4 {
  padding-left: 0 !important;
  margin-left: 0 !important;
}
.ul_disc {
  list-style-type: disc;
  margin: 4pt 0 10pt 0;
  padding-left: 0;
  margin-left: 0;
}
.ul_disc li { margin-bottom: 4pt; }
/* GHG DOCX: remove section/card wrapper padding & margin (live outerHTML + saved HTML) */
.Main_Section_card {
  margin: 0 !important;
  padding: 0 !important;
}
section.Main_Section.ghg-section {
  margin: 0 !important;
  padding: 0 !important;
}
.ghg-section .ETA_card_Section,
.ETA_card_main.GHG_CardMain .ETA_card_Section {
  padding: 0 !important;
  margin: 0 !important;
}
.ghg-section .ETA_card_Section_sub,
.ETA_card_main.GHG_CardMain .ETA_card_center .Main_Section .ETA_card_Section .ETA_card_Section_sub {
  margin: 0 !important;
  padding: 0 !important;
}
.ghg-section .ETA_card_Section_head:not(.ghg-section-head-bar) {
  margin: 0 !important;
  padding: 0 !important;
}
h6 {
  font-size: 13px;
  font-weight: 600;
  margin: 4pt 0 3pt 0;
  line-height: 1.35;
}
p { margin: 0 0 6pt 0; line-height: 1.45; }
thead { display: table-header-group; }
.Main_Section_card > section.ghg-section ~ section.ghg-section {
  page-break-before: always;
  break-before: page;
}
.ghg-section-head-bar {
  background-color: #4f46e5;
  padding: 5px 5px 5px 0;
  padding-left: 0 !important;
  margin: 0 !important;
  margin-left: 0 !important;
}
.ghg-section-head-bar h5 {
  color: #ffffff !important;
  font-size: 18pt;
  font-weight: 700;
  margin: 0 !important;
  margin-left: 0 !important;
  padding: 0 !important;
  padding-left: 0 !important;
}
.ghg-section-subhead-title {
  font-size: 12pt;
  font-weight: 700;
  color: #1e293b;
  margin: 0 !important;
  margin-left: 0 !important;
  padding: 0 !important;
  padding-left: 0 !important;
}
.ghg-section table thead th {
  background-color: #f1f5f9 !important;
}
`.trim();

/**
 * Appended only for GHG html-docx-js exports (filename GHG_*.docx or ReportExportModal GHG).
 * Full-width tables & paragraphs; strip extra padding/margins Word would otherwise widen.
 */
export const WORD_DOCX_GHG_TABLE_P_FULL_WIDTH_CSS = `
body {
  margin: 0 !important;
  padding: 0 !important;
}
body table:not(.ghg-toc-badge-table) {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
  margin: 0 !important;
  padding: 0 !important;
  border-collapse: collapse !important;
  border: none !important;
  outline: none !important;
  table-layout: auto !important;
}
body .ghg-word-toc table.ghg-toc-flat-grid,
body .ghg-word-toc table.ghg-toc-grid-table,
body .ghg-word-toc table.ghg-toc-row-table {
  table-layout: fixed !important;
  mso-table-layout-alt: fixed !important;
}
body table:not(.ghg-toc-flat-grid) col,
body table:not(.ghg-toc-flat-grid) colgroup col {
  width: auto !important;
}
body .ghg-word-toc table.ghg-toc-flat-grid col:nth-child(1),
body .ghg-word-toc table.ghg-toc-flat-grid col:nth-child(3) {
  width: 44pt !important;
}
body table.table-bordered {
  border: none !important;
  outline: none !important;
}
/* Data tables only — never cover/TOC layout tables (cover uses table rows for layout) */
body section.ghg-section table th,
body section.ghg-section table td,
body .ghg-section table th,
body .ghg-section table td,
body table.table th,
body table.table td,
body .table th,
body .table td {
  width: auto;
  padding: 1pt 2pt !important;
  margin: 0 !important;
  border: 1px solid #dee2e6 !important;
  border-width: 1px !important;
}
body section.ghg-section table th.text-right,
body section.ghg-section table td.text-right,
body section.ghg-section table th.text-end,
body section.ghg-section table td.text-end,
body table.table th.text-right,
body table.table td.text-right,
body table.table th.text-end,
body table.table td.text-end {
  text-align: right !important;
}
body .ghg-word-toc table.ghg-toc-layout-table > tbody > tr > td.ghg-toc-cell,
body .ghg-word-toc table.ghg-toc-layout-table > tr > td.ghg-toc-cell,
body .ghg-word-toc table th {
  border: none !important;
}
body .ghg-word-toc table.ghg-toc-flat-grid td.ghg-toc-badge-cell,
body .ghg-word-toc table.ghg-toc-flat-grid td.ghg-toc-text-cell {
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
}
body .table,
body table.table {
  width: 100% !important;
  max-width: 100% !important;
  margin-bottom: 0 !important;
}
body .table > :not(caption) > * > *,
body .table-bordered > :not(caption) > * > *,
body .table-sm > :not(caption) > * > * {
  padding: 1pt 2pt !important;
}
body p {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
  margin: 0 !important;
  padding: 0 !important;
}
body td p,
body th p,
body li p {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}
/* GHG TOC: never use width:auto on nested tables in Word; pin badge + row layout explicitly */
body .ghg-word-toc table.ghg-toc-badge-table {
  width: 44pt !important;
  max-width: 44pt !important;
  min-width: 44pt !important;
  height: 44pt !important;
  border: none !important;
}
body .ghg-word-toc table.ghg-toc-badge-table td {
  width: 44pt !important;
  max-width: 44pt !important;
  padding: 0 !important;
  border: none !important;
  border-radius: 8px !important;
}
body .ghg-word-toc table.ghg-toc-row-table {
  width: 100% !important;
  max-width: 100% !important;
  table-layout: fixed !important;
  mso-table-layout-alt: fixed !important;
}
body .ghg-word-toc {
  width: 8.27in !important;
  max-width: 8.27in !important;
  margin: 0 auto !important;
  box-sizing: border-box !important;
}
body .ghg-word-toc .ghg-toc-page-shell {
  width: 8.27in !important;
  max-width: 8.27in !important;
  box-sizing: border-box !important;
}
body .ghg-word-toc table.ghg-toc-page-layout-table {
  width: 100% !important;
  max-width: 100% !important;
  min-height: 8.35in !important;
  border: none !important;
  border-collapse: collapse !important;
}
body .ghg-word-toc .ghg-toc-footer-gap-cell {
  height: 20pt !important;
  line-height: 20pt !important;
  padding: 0 !important;
  border: none !important;
}
body .ghg-word-toc .ghg-toc-footer-spacer-cell {
  height: 96pt !important;
  line-height: 1pt !important;
  padding: 0 !important;
  border: none !important;
}
body .ghg-word-toc .ghg-toc-footer-bar-cell {
  vertical-align: bottom !important;
  padding: 0 !important;
  border: none !important;
}
body .ghg-word-toc table.ghg-toc-footer-bar {
  width: 100% !important;
  margin: 0 !important;
  border: none !important;
}
body .ghg-word-toc table.ghg-toc-flat-grid {
  width: 100% !important;
  max-width: 100% !important;
  table-layout: fixed !important;
  mso-table-layout-alt: fixed !important;
}
body .ghg-word-toc table.ghg-toc-flat-grid col.ghg-toc-col-badge,
body .ghg-word-toc table.ghg-toc-flat-grid col:nth-child(1),
body .ghg-word-toc table.ghg-toc-flat-grid col:nth-child(3) {
  width: 44pt !important;
}
body .ghg-word-toc table.ghg-toc-flat-grid col.ghg-toc-col-text,
body .ghg-word-toc table.ghg-toc-flat-grid col:nth-child(2),
body .ghg-word-toc table.ghg-toc-flat-grid col:nth-child(4) {
  width: 191pt !important;
}
body .ghg-word-toc table.ghg-toc-row-table td.ghg-toc-badge-cell {
  width: 44pt !important;
  max-width: 44pt !important;
  min-width: 44pt !important;
  padding-left: 0 !important;
  padding-right: 11pt !important;
  vertical-align: top !important;
  border: none !important;
}
body .ghg-word-toc table.ghg-toc-row-table td.ghg-toc-text-cell {
  width: 191pt !important;
  max-width: 191pt !important;
  vertical-align: top !important;
  padding: 0 !important;
  border: none !important;
  word-wrap: break-word !important;
}
body .ghg-word-toc table.ghg-toc-flat-grid > tbody > tr > td.ghg-toc-badge-cell,
body .ghg-word-toc table.ghg-toc-flat-grid > tr > td.ghg-toc-badge-cell {
  width: 44pt !important;
  max-width: 44pt !important;
  min-width: 44pt !important;
  padding-left: 0 !important;
  padding-right: 11pt !important;
  vertical-align: top !important;
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
  border-bottom: none !important;
  mso-border-bottom-alt: none !important;
  overflow: visible !important;
}
body .ghg-word-toc table.ghg-toc-flat-grid > tbody > tr > td.ghg-toc-text-cell:nth-child(2),
body .ghg-word-toc table.ghg-toc-flat-grid > tr > td.ghg-toc-text-cell:nth-child(2) {
  padding-right: 12pt !important;
}
body .ghg-word-toc table.ghg-toc-flat-grid > tbody > tr > td.ghg-toc-text-cell,
body .ghg-word-toc table.ghg-toc-flat-grid > tr > td.ghg-toc-text-cell {
  width: 191pt !important;
  max-width: 191pt !important;
  vertical-align: top !important;
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
  border-bottom: none !important;
  mso-border-bottom-alt: none !important;
  word-wrap: break-word !important;
}
body .ghg-word-toc td.ghg-toc-text-cell p,
body .ghg-word-toc td.ghg-toc-text-cell p.ghg-toc-title,
body .ghg-word-toc td.ghg-toc-text-cell p.ghg-toc-subtitle {
  width: auto !important;
  max-width: 100% !important;
  word-wrap: break-word !important;
  mso-line-height-rule: exactly !important;
}
body .ghg-word-toc table.ghg-toc-grid-table:not(.ghg-toc-flat-grid) > tbody > tr > td,
body .ghg-word-toc table.ghg-toc-grid-table:not(.ghg-toc-flat-grid) > tr > td {
  width: 50% !important;
  vertical-align: top !important;
  border: none !important;
}
body .ghg-word-toc table.ghg-toc-grid-table > tbody > tr,
body .ghg-word-toc table.ghg-toc-grid-table > tr {
  vertical-align: top !important;
}
body .ghg-word-toc .ghg-toc-badge-wrap {
  display: block !important;
  width: 44pt !important;
  height: 44pt !important;
  line-height: 0 !important;
  font-size: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}
body .ghg-word-toc img.ghg-toc-number-badge-img {
  display: block !important;
  width: 44pt !important;
  height: 44pt !important;
  max-height: 44pt !important;
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
}
body .ghg-word-toc td.ghg-toc-text-cell p {
  width: auto !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}
body .ghg-word-toc td.ghg-toc-text-cell p + p {
  margin-top: 3pt !important;
  mso-margin-top-alt: 3pt !important;
}
/* GHG TOC: paired rows — 01/06, 02/07, etc. share one table row for column alignment */
body .ghg-word-toc td.ghg-toc-item-cell {
  vertical-align: top !important;
  border: none !important;
}
body .ghg-word-toc td.ghg-toc-grid-left {
  padding-right: 14pt !important;
}
body .ghg-word-toc td.ghg-toc-grid-right {
  padding-left: 14pt !important;
}
body .ghg-word-toc > div > table {
  border: none !important;
}
body .ghg-cover-label-badge-img img,
body .ghg-toc-label-badge-img img,
body .ghg-cover-meta-icon-img {
  border: none !important;
  display: block !important;
}
/* Cover page only at DOCX export — shell + layout tables (global body table td borders look like a card frame) */
body .ghg-cover-page,
body .ghg-word-cover-export,
body .ghg-word-export-page {
  border: none !important;
  border-width: 0 !important;
  outline: none !important;
  box-shadow: none !important;
}
body .ghg-cover-page table,
body .ghg-word-cover-export table,
body .ghg-word-export-page table,
body .word-cover-page .ghg-cover-page table {
  border: none !important;
  border-width: 0 !important;
  border-collapse: collapse !important;
  mso-border-alt: none !important;
}
body .ghg-cover-page table td,
body .ghg-cover-page table th,
body .ghg-word-cover-export table td,
body .ghg-word-cover-export table th,
body .ghg-word-export-page table td,
body .ghg-word-export-page table th,
body .word-cover-page .ghg-cover-page table td,
body .word-cover-page .ghg-cover-page table th {
  border: none !important;
  border-width: 0 !important;
  mso-border-alt: none !important;
}
body .word-cover-page,
body .word-cover-content {
  background-color: transparent !important;
  border: none !important;
  padding: 0 !important;
}
body img.ghg-cover-logo,
body .word-cover-page img.ghg-cover-logo,
body .ghg-word-export-page img.ghg-cover-logo,
body .ghg-word-cover-export img.ghg-cover-logo,
body #Section_Cover .report-company-logo img,
body section.GHGSection_cover .report-company-logo img {
  height: ${COVER_LOGO_H} !important;
  max-height: ${COVER_LOGO_H} !important;
  width: auto !important;
  max-width: ${COVER_LOGO_MAX_W} !important;
}
body section.GHGSection_cover,
body section#Section_Cover,
body .GHGSection_cover .ETA_card_Section {
  border: none !important;
  border-width: 0 !important;
  outline: none !important;
  box-shadow: none !important;
  mso-border-alt: none !important;
}
body section.GHGSection_cover table,
body section.GHGSection_cover table td,
body section.GHGSection_cover table th,
body section#Section_Cover table,
body section#Section_Cover table td,
body section#Section_Cover table th {
  border: none !important;
  border-width: 0 !important;
  mso-border-alt: none !important;
}
`.trim();

/** Injected in GHG Word export <head> — cover shell + layout tables must have zero borders in Word */
export const WORD_DOCX_GHG_COVER_NO_BORDER_CSS = `
div.ghg-cover-page,
div.ghg-word-cover-export,
div.ghg-word-export-page,
section.GHGSection_cover,
section#Section_Cover {
  border: none !important;
  border-width: 0 !important;
  border-style: none !important;
  outline: none !important;
  box-shadow: none !important;
  mso-border-alt: none !important;
}
div.ghg-cover-page table,
div.ghg-word-cover-export table,
div.ghg-word-export-page table,
section.GHGSection_cover table,
section#Section_Cover table,
.ghg-cover-layout-table {
  border: none !important;
  border-width: 0 !important;
  border-collapse: collapse !important;
  mso-border-alt: none !important;
  mso-table-lspace: 0pt !important;
  mso-table-rspace: 0pt !important;
}
div.ghg-cover-page table td,
div.ghg-cover-page table th,
div.ghg-cover-page table tr,
div.ghg-word-cover-export table td,
div.ghg-word-cover-export table th,
div.ghg-word-cover-export table tr,
div.ghg-word-export-page table td,
div.ghg-word-export-page table th,
div.ghg-word-export-page table tr,
section.GHGSection_cover table td,
section.GHGSection_cover table th,
section.GHGSection_cover table tr,
section#Section_Cover table td,
section#Section_Cover table th,
section#Section_Cover table tr,
.ghg-cover-layout-table td,
.ghg-cover-layout-table th,
.ghg-cover-layout-table tr,
.ghg-cover-cell {
  border: none !important;
  border-width: 0 !important;
  border-style: none !important;
  mso-border-alt: none !important;
  mso-border-top-alt: none !important;
  mso-border-bottom-alt: none !important;
  mso-border-left-alt: none !important;
  mso-border-right-alt: none !important;
}
`.trim();

/** Overrides BRSR_EXPORT global th/td borders on GHG cover when list export uses downloadBRSRReportWord */
export const WORD_DOCX_GHG_COVER_BRSR_TABLE_BORDER_RESET_CSS = `
.ghg-cover-page table,
.ghg-cover-page th,
.ghg-cover-page td,
.ghg-cover-page tr,
.ghg-word-export-page table,
.ghg-word-export-page th,
.ghg-word-export-page td,
.ghg-word-cover-export table,
.ghg-word-cover-export th,
.ghg-word-cover-export td,
section.GHGSection_cover table,
section.GHGSection_cover th,
section.GHGSection_cover td,
section#Section_Cover table,
section#Section_Cover th,
section#Section_Cover td,
.ghg-cover-layout-table,
.ghg-cover-layout-table td,
.ghg-cover-layout-table th,
.ghg-cover-cell {
  border: none !important;
  border-width: 0 !important;
  border-style: none !important;
  mso-border-alt: none !important;
}
div.ghg-cover-page,
div.ghg-word-cover-export {
  border: none !important;
  border-width: 0 !important;
}
`.trim();
